import React, { PropsWithChildren } from 'react'
import { Flex, Text } from '@workwhile/ui'

type FooterProps = {
  error?: string
}

export const Footer = ({ error, children }: PropsWithChildren<FooterProps>) => {
  return (
    <Flex
      gap={2}
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      minHeight="auto"
    >
      {error ? <Text color="error100">{error}</Text> : null}
      <Flex flexDirection="row" gap={2} justifyContent="flex-end" flex={1}>
        {children}
      </Flex>
    </Flex>
  )
}
